export default __webpack_public_path__ + "static/media/shippingInfo.5bd7bc74.svg";